import { Component, Input, Output, EventEmitter, ViewChild, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicComponentDirective } from '../../../directives/dynamic-component.directive';
import * as Models from '../../../models/models-index';
import { PanelElementResolverService } from '../panel-element-resolver.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import * as SharedServices from '../../../../_shared/services/services-index';

@Component({
  selector: 'overview-full-width-panel',
  templateUrl: './overview-full-width-panel.component.html',
  styleUrls: ['./overview-full-width-panel.component.scss']
})

export class OverviewFullWidthPanelComponent implements Models.PanelComponent {

  @ViewChild(DynamicComponentDirective, { static: true }) dynamicComponent!: DynamicComponentDirective;
  @Input() panelConfig: Models.Panel;
  private componentInstances: Models.ElementComponent[] = [];

  private _dataSets: Models.DataSet[] = [];
  @Input()
  set dataSets(value: Models.DataSet[]) {
    this._dataSets = value;
    if(this._dataSets?.length > 0)
    {
      this.assignDataToElement();
      return;
    }

    this.componentInstances.forEach(instance => {
      instance.dataSets = null;
    });
  }
  get dataSets(): Models.DataSet[] {
    return this._dataSets;
  }

  @Input() rowPanelId: string;
  @Input() translationService?: Models.ITranslationService;
  @Input() viewContext?: Models.ViewContext;
  @Output() openHelpText = new EventEmitter();
  @Output() changeMetricSelect = new EventEmitter();

  panelConfiguration: Models.PanelConfiguration;

  constructor(
    private resolverService: PanelElementResolverService,
    private renderer2: Renderer2,
    private router: Router,
    private helpTextService: SharedServices.HelpTextService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.panelConfiguration = this.panelConfig.configurations[0];
    this.generateElements(this.panelConfiguration);
  }

  metricSelectChanged(): void {
    this.changeMetricSelect.emit();
  }

  openHelpTextClicked(): void {
    this.helpTextService.openHelp(this.panelConfiguration.helpTextKey, this.panelConfiguration.helpTextTitle);
  }

  handleTitleClick() {
    let filterOverrides = [];
    this.panelConfiguration.titleLinkUrlFilters.forEach(filter => {
      filterOverrides.push({type: filter.type, values: filter.values})
    })

    this.router.navigate([this.panelConfiguration.titleLinkUrl], { state: { filterOverrides: filterOverrides } })
  }

  generateElements(panelConfig) {
    const viewContainerRef = this.dynamicComponent.viewContainerRef;
    viewContainerRef.clear();
    this.componentInstances = [];

    panelConfig.elements.forEach(element => {
      const componentRef = this.resolverService.resolveElementComponent(viewContainerRef, element.type);
      this.componentInstances.push(componentRef.instance);
      componentRef.instance.settings = element.settings;
      componentRef.instance.viewContext = this.viewContext;
      this.renderer2.addClass(componentRef.location.nativeElement, 'panel-element');
    })
  }

  private assignDataToElement(): void {
    this.componentInstances.forEach(instance => {
      const elementDataSets = instance.settings.dataSets ?? [instance.settings.dataSet];
      const dataSets = this.dataSets.filter(dataSet => elementDataSets.includes(dataSet.name));
      instance.dataSets = dataSets;
    });
  }
}
